import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChecklist = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Document Checkmark",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Shape",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M18.5 20C18.5 20.275 18.276 20.5 18 20.5H12.2678C11.9806 21.051 11.6168 21.5557 11.1904 22H18C19.104 22 20 21.104 20 20V9.828C20 9.298 19.789 8.789 19.414 8.414L13.585 2.586C13.57 2.57105 13.5531 2.55808 13.5363 2.5452C13.5238 2.53567 13.5115 2.5262 13.5 2.516C13.429 2.452 13.359 2.389 13.281 2.336C13.2557 2.31894 13.2281 2.30548 13.2005 2.29207C13.1845 2.28426 13.1685 2.27647 13.153 2.268C13.1363 2.25859 13.1197 2.24897 13.103 2.23933C13.0488 2.20797 12.9944 2.17648 12.937 2.152C12.74 2.07 12.528 2.029 12.313 2.014C12.2933 2.01274 12.2738 2.01008 12.2542 2.00741C12.2271 2.00371 12.1999 2 12.172 2H6C4.896 2 4 2.896 4 4V11.4982C4.47417 11.3004 4.97679 11.1572 5.5 11.0764V4C5.5 3.725 5.724 3.5 6 3.5H12V8C12 9.104 12.896 10 14 10H18.5V20ZM13.5 4.621L17.378 8.5H14C13.724 8.5 13.5 8.275 13.5 8V4.621Z",
				fill: "#121212"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M12 17.5C12 20.5376 9.53757 23 6.5 23C3.46243 23 1 20.5376 1 17.5C1 14.4624 3.46243 12 6.5 12C9.53757 12 12 14.4624 12 17.5ZM9.85355 15.1464C9.65829 14.9512 9.34171 14.9512 9.14645 15.1464L5.5 18.7929L3.85355 17.1464C3.65829 16.9512 3.34171 16.9512 3.14645 17.1464C2.95118 17.3417 2.95118 17.6583 3.14645 17.8536L5.14645 19.8536C5.34171 20.0488 5.65829 20.0488 5.85355 19.8536L9.85355 15.8536C10.0488 15.6583 10.0488 15.3417 9.85355 15.1464Z",
				fill: "#121212"
			})]
		})
	})
});
export default SvgChecklist;
